import { useSelector } from "react-redux";

import { openChatReplyPause } from "../shared/hitl/actionPause";
import { lastHumanReviewMessage, threadMessages } from "./useThreadWait";

/** The composer's placeholder while Theo's question can be answered from the chat. */
export const CHAT_REPLY_PLACEHOLDER = "Reply to Theo's question…";

/** The placeholder for this thread's messages: set while its last card is an open `chat_reply` card. */
export function chatReplyPlaceholder(messages: any[]): string | null {
  const last = lastHumanReviewMessage(messages);
  if (!last) return null;
  return openChatReplyPause(last.human_review, last.human_review_status) ? CHAT_REPLY_PLACEHOLDER : null;
}

/**
 * The composer's placeholder while the thread's open card takes a chat reply, else null.
 *
 * Such a card never shuts the composer: a message typed while it is open is a normal send, and
 * Cortex reads it as the card's answer instead of cancelling the card. The placeholder is the only
 * thing that changes, so the technician knows the next message answers Theo.
 */
const useChatReplyPlaceholder = (aiThreadId: string | number | null | undefined): string | null =>
  useSelector((state: any) => {
    const threadKey = aiThreadId != null ? String(aiThreadId) : null;
    if (!threadKey) return null;
    return chatReplyPlaceholder(threadMessages(state?.chat, threadKey));
  });

export default useChatReplyPlaceholder;
